<script>
export default {
  data() {
    return {
      entry: {
        id: this.editing ? null : this.$route.params.id
      },
      resource: {
        name: "users",
        ready: false,
        mode: this.$route.meta.mode,
        routes: {
          show: "",
          update: "",
          destroy: "",
          store: ""
        },
        endpoint: ""
      },
      errors: {},
      saving: false
    };
  },
  computed: {
    editing() {
      return this.resource.mode !== "create";
    }
  },
  methods: {
    setCustomer(value) {
      this.entry.customer_id = value.id

      if (this.entry.customer_id === -1) {
        this.entry.customer_id = null;
        this.showCustomerModal = true;
      } else {
        this.entry.customer = value

        if (!this.editing) {
          this.entry.partner_id = this.entry.customer.partner_id;
          this.entry.seller_id = this.entry.customer.seller_id;
        }
      }
    },
    fetchCustomers(search = '') {
      axios.get("/admin/customers/all", {
        params: {
          search: search
        }
      }).then((response) => {
        this.selects.customers = response.data.data.map((customer) => {
          return {
            ...customer,
            label: customer.full_name + ", " + customer.phone,
          };
        });
      });
    },
    /**
     * Callbacks
     */
    onFetch() {
      // console.log('loaded');
    },
    onStore() {
      this.$message.success("Запись создана");

      this.$router.push({
        name: this.resource.name + ".edit",
        params: {
          id: this.entry.id
        }
      });
    },
    onUpdate() {
      this.$message.success("Запись обновлена");
    },
    onDestroy() {
      this.$message.success("Запись удалена");

      this.$router.push({
        name: this.resource.name + ".index"
      });
    },
    onError(message) {
      this.$message.error(message);
    },

    /**
     * Default methods
     */
    fetch() {
      axios
          .get(this.resource.routes.show)
          .then(response => {
            this.entry = response.data.data;
            this.onFetch();
            this.resource.ready = true;
          })
          .catch(error => {
            console.log(error.response.data);
          });
    },
    submit() {
      if (this.editing) {
        this.update();
      } else {
        this.store();
      }
    },
    store() {
      this.saving = true;
      axios
          .post(this.resource.routes.store, this.entry)
          .then(response => {
            this.entry = response.data.data;
            this.onStore();
            this.errors = {};
            this.saving = false;
          })
          .catch(error => {
            this.saving = false;
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            }
            if (error.response.data.message) {
              this.onError(error.response.data.message);
            }
          });
    },
    update() {
      if (this.canUpdate != undefined && !this.canUpdate) {
        return false;
      }

      this.saving = true;
      axios
          .put(this.resource.routes.update, this.entry)
          .then(response => {
            this.onUpdate();
            this.errors = {};
            this.saving = false;
          })
          .catch(error => {
            this.saving = false;
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            }
            if (error.response.data.message) {
              this.onError(error.response.data.message);
            }
          });
    },
    destroy() {
      axios
          .delete(this.resource.routes.destroy)
          .then(response => {
            this.onDestroy();
            this.errors = {};
          })
          .catch(error => {
            if (error.response.data.errors) {
              this.errors = error.response.data.errors;
            }
            if (error.response.data.message) {
              this.onError(error.response.data.message);
            }
          });
    }
  },
  mounted() {
    this.resource.routes.show = this.resource.routes.show
        ? this.resource.routes.show
        : this.resource.endpoint + "/" + this.entry.id;
    this.resource.routes.update = this.resource.routes.update
        ? this.resource.routes.update
        : this.resource.endpoint + "/" + this.entry.id;
    this.resource.routes.destroy = this.resource.routes.destroy
        ? this.resource.routes.destroy
        : this.resource.endpoint + "/" + this.entry.id;
    this.resource.routes.store = this.resource.routes.store
        ? this.resource.routes.store
        : this.resource.endpoint;

    if (this.editing) {
      this.fetch();
    } else {
      this.resource.ready = true;
    }
  }
};
</script>